const numberFormatter = (value) => {
  const formatter = new Intl.NumberFormat('pt-BR');

  if (!value) return formatter.format(0);

  return formatter.format(value);
};

export default numberFormatter;
